//# sourceMappingURL=checkbox.mjs.map
/// <reference types="./checkbox.d.mts" />
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $a from "../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $h from "../../../redraw_dom/redraw/dom/html.mjs";
import { toList, CustomType as $CustomType } from "../../gleam.mjs";

export class ContentControl extends $CustomType {}
export const CheckBoxType$ContentControl = () => new ContentControl();
export const CheckBoxType$isContentControl = (value) =>
  value instanceof ContentControl;

export class LegacyFormField extends $CustomType {}
export const CheckBoxType$LegacyFormField = () => new LegacyFormField();
export const CheckBoxType$isLegacyFormField = (value) =>
  value instanceof LegacyFormField;

export class CheckboxElement extends $CustomType {
  constructor(checked, checkbox_id, label, tag, symbol, checkbox_type) {
    super();
    this.checked = checked;
    this.checkbox_id = checkbox_id;
    this.label = label;
    this.tag = tag;
    this.symbol = symbol;
    this.checkbox_type = checkbox_type;
  }
}
export const CheckboxElement$CheckboxElement = (checked, checkbox_id, label, tag, symbol, checkbox_type) =>
  new CheckboxElement(checked, checkbox_id, label, tag, symbol, checkbox_type);
export const CheckboxElement$isCheckboxElement = (value) =>
  value instanceof CheckboxElement;
export const CheckboxElement$CheckboxElement$checked = (value) => value.checked;
export const CheckboxElement$CheckboxElement$0 = (value) => value.checked;
export const CheckboxElement$CheckboxElement$checkbox_id = (value) =>
  value.checkbox_id;
export const CheckboxElement$CheckboxElement$1 = (value) => value.checkbox_id;
export const CheckboxElement$CheckboxElement$label = (value) => value.label;
export const CheckboxElement$CheckboxElement$2 = (value) => value.label;
export const CheckboxElement$CheckboxElement$tag = (value) => value.tag;
export const CheckboxElement$CheckboxElement$3 = (value) => value.tag;
export const CheckboxElement$CheckboxElement$symbol = (value) => value.symbol;
export const CheckboxElement$CheckboxElement$4 = (value) => value.symbol;
export const CheckboxElement$CheckboxElement$checkbox_type = (value) =>
  value.checkbox_type;
export const CheckboxElement$CheckboxElement$5 = (value) => value.checkbox_type;

export function checkbox_type_decoder() {
  return $decode.then$(
    $decode.string,
    (string) => {
      if (string === "content_control") {
        return $decode.success(new ContentControl());
      } else if (string === "legacy_form_field") {
        return $decode.success(new LegacyFormField());
      } else {
        return $decode.failure(new ContentControl(), "checkbox_type");
      }
    },
  );
}

export function encode_checkbox_type(checkbox_type) {
  if (checkbox_type instanceof ContentControl) {
    return $json.string("content_control");
  } else {
    return $json.string("legacy_form_field");
  }
}

export function decoder() {
  return $decode.field(
    "checked",
    $decode.bool,
    (checked) => {
      return $decode.field(
        "checkbox_id",
        $decode.optional($decode.string),
        (checkbox_id) => {
          return $decode.field(
            "label",
            $decode.optional($decode.string),
            (label) => {
              return $decode.field(
                "tag",
                $decode.optional($decode.string),
                (tag) => {
                  return $decode.field(
                    "symbol",
                    $decode.optional($decode.string),
                    (symbol) => {
                      return $decode.field(
                        "checkbox_type",
                        checkbox_type_decoder(),
                        (checkbox_type) => {
                          return $decode.success(
                            new CheckboxElement(
                              checked,
                              checkbox_id,
                              label,
                              tag,
                              symbol,
                              checkbox_type,
                            ),
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

export function encode(checkbox) {
  return $json.object(
    toList([
      ["type", $json.string("checkbox")],
      ["checked", $json.bool(checkbox.checked)],
      ["checkbox_id", $json.nullable(checkbox.checkbox_id, $json.string)],
      ["label", $json.nullable(checkbox.label, $json.string)],
      ["tag", $json.nullable(checkbox.tag, $json.string)],
      ["symbol", $json.nullable(checkbox.symbol, $json.string)],
      ["checkbox_type", encode_checkbox_type(checkbox.checkbox_type)],
    ]),
  );
}

function checkbox_type_to_string(checkbox_type) {
  if (checkbox_type instanceof ContentControl) {
    return "content_control";
  } else {
    return "legacy_form_field";
  }
}

export function to_html(checkbox) {
  let type_attr = $a.attribute("type", "checkbox");
  let _block;
  let $ = checkbox.checked;
  if ($) {
    _block = $a.attribute("checked", "checked");
  } else {
    _block = $a.none();
  }
  let checked_attr = _block;
  let _block$1;
  let $1 = checkbox.checkbox_id;
  if ($1 instanceof Some) {
    let id = $1[0];
    _block$1 = $a.attribute("data-checkbox-id", id);
  } else {
    _block$1 = $a.none();
  }
  let checkbox_id_attr = _block$1;
  let _block$2;
  let $2 = checkbox.label;
  if ($2 instanceof Some) {
    let label = $2[0];
    _block$2 = $a.attribute("data-label", label);
  } else {
    _block$2 = $a.none();
  }
  let label_attr = _block$2;
  let _block$3;
  let $3 = checkbox.tag;
  if ($3 instanceof Some) {
    let tag = $3[0];
    _block$3 = $a.attribute("data-tag", tag);
  } else {
    _block$3 = $a.none();
  }
  let tag_attr = _block$3;
  let checkbox_type_str = checkbox_type_to_string(checkbox.checkbox_type);
  let checkbox_type_attr = $a.attribute("data-checkbox-type", checkbox_type_str);
  return $h.element(
    "input",
    toList([
      type_attr,
      checked_attr,
      checkbox_id_attr,
      label_attr,
      tag_attr,
      checkbox_type_attr,
    ]),
    toList([]),
  );
}
